import React from "react";
import "./home.css";


export const Home = () => {
  return (
    <div className="portfolio-page-1">
    <div id="name-div"><p id="name">Kishore P VIT Chennai</p></div>        
      <div className="mac-1">
        <div id="strips">
            <div id="green"/>
            <div id="red"/>
            <div id="yellow"/>
            <div id="blue"/>
            <div id="pink" />
        </div>
        <div id="strips-div">
          <p id="port">PORT</p>
          <p id="folio">FOLIO</p>

        </div>
      </div>
    </div>
  );
};


export default Home;